import { Component } from 'preact'
import { t } from 'libs/translationsUtils/translations'
import likePostRequest from 'utils/likePostRequest'

export default class TopicListLikeButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hasCurrentUserLiked: props.topic.hasCurrentUserLiked,
      numberOfLikes: props.topic.numberOfLikes
    }

    this.likeTopicHandler = this.likeTopicHandler.bind(this)
  }

  likeTopicHandler () {
    const { isGuest, topic } = this.props
    const { id } = topic.firstPost
    const { hasCurrentUserLiked, numberOfLikes } = this.state

    if (isGuest) {
      // eslint-disable-next-line no-undef
      const event = new Event('GuestUserAction')

      return window.dispatchEvent(event)
    }

    this.setState({
      hasCurrentUserLiked: !hasCurrentUserLiked,
      numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
    })

    likePostRequest(topic.id, id, !hasCurrentUserLiked, (err) => {
      if (err) {
        this.setState({
          hasCurrentUserLiked: !hasCurrentUserLiked,
          numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
        })
        console.error(err)
      }
    })
  }

  render (props, state) {
    const { isIdeation } = props.topic.forum
    const { hasCurrentUserLiked, numberOfLikes } = state
    let likeBtnClass = 'thread-meta-item thread-meta-item--hover-highlight thread-meta-item--likes qa-topic-meta-likes-icon'
    let voteBtnClass = 'thread-meta-item btn--toggle thread-meta-item--vote qa-topic-meta-likes-icon'

    if (hasCurrentUserLiked) {
      likeBtnClass += ' thread-meta-item--likes--liked'
      voteBtnClass += ' preact_voted'
    }

    return (
      !isIdeation ? (
        <button class={likeBtnClass} onClick={this.likeTopicHandler} type='button'>
          <i class='thread-meta-item__icon icon--auto-width icon--thumb-up' />
          <span class='thread-meta-item__text js-vote-count qa-topic-meta-likes-content'>
            {numberOfLikes}
          </span>
        </button>
      ) : (
        <button class={voteBtnClass} onClick={this.likeTopicHandler} type='button'>
          {
            hasCurrentUserLiked ? (
              <span class='thread-meta-item__text--voted voted preact_voted-button'>
                {t('Forum', 'topicList.meta.voted')}
              </span>
            ) : (
              <span class='thread-meta-item__text--vote'>
                {t('Forum', 'topicList.meta.vote')}
              </span>
            )
          }
          <span class='qa-topic-meta-likes-content'>{numberOfLikes}</span>
        </button>
      )
    )
  }
}
